interface IPaginationProps {
  currentPage: number;
  totalItems: number;
  itemsPerPage: number;
  onPageChange: (page: number) => void;
}

const Pagination = (props: IPaginationProps) => {
  const totalPages = Math.ceil(props.totalItems / props.itemsPerPage);
  const isFirstPage = props.currentPage === 1;
  const isLastPage = props.currentPage >= totalPages;

  if (props.totalItems === 0) {
    return null;
  }

  return (
    <div className="flex justify-center items-center gap-2 mt-6">
      <button
        className="px-3 py-1 text-size-16 bg-white text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white"
        onClick={() => props.onPageChange(props.currentPage - 1)}
        disabled={isFirstPage}
      >
        <span className="rioglyph rioglyph-chevron-left text-gray-300"></span>
      </button>
      <div className="ml-2 mr-2 px-4 py-1 text-size-16 bg-gray-400 text-gray-100 font-bold cursor-default">
        {props.currentPage}
      </div>
      <button
        className="px-3 py-1 text-size-16 bg-white text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white"
        onClick={() => props.onPageChange(props.currentPage + 1)}
        disabled={isLastPage}
      >
        <span className="rioglyph rioglyph-chevron-right text-gray-300"></span>
      </button>
    </div>
  );
};

export default Pagination;

